import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import image from 'Assets/quoteInsurance.jpg'

import { WAITING_MESSAGES } from 'Global/messages'

import useRedux from './Redux'
import { FORM_ACTIONS } from './Redux/actions'
import SELECTOR from './Redux/selectors'
import { selectProducts } from 'Redux/Global/selectors'

import { useWindowDimensions } from 'Components/WindowDimensions'

import Page from 'Components/Page'
import Form from 'Components/Form'
import Loading from 'Components/Loading'
import HeroImage from 'Components/HeroImage'

import { Container, ProductTitle } from './style'

const RatesForm = () => {
  useRedux()
  const [verificationId, setVerificationId] = useState(null)
  const [heightLoading, setHeightLoading] = useState(0)
  const dispatch = useDispatch()

  const device = useWindowDimensions()

  const loading = useSelector(SELECTOR.LOADING)
  const form = useSelector(SELECTOR.FORM)
  const values = useSelector(SELECTOR.VALUES)
  const done = useSelector(SELECTOR.DONE)
  const productId = useSelector(SELECTOR.PRODUCT_ID)
  const products = useSelector(selectProducts)

  useEffect(() => {
    dispatch(FORM_ACTIONS.GET())
  }, [])

  const handleSubmit = values => {
    dispatch(FORM_ACTIONS.SAVE({ ...values, verificationId: verificationId }))
  }

  const handleValidation = id => {
    setVerificationId(id)
  }

  const getForm = () => {
    if (Object.keys(form).length === 0) {
      return
    }
    const text = ['Siguiente', 'Cotizar']

    return (
      <Form
        fromWhere='ratesForm'
        rawForms={form}
        oldValues={values}
        submit={handleSubmit}
        /* sms */
        handleValidation={handleValidation}
        buttonText={text}
        recaptcha
      />
    )
  }

  useEffect(() => {
    const heightHeader = document.querySelector('header')?.clientHeight
    const heightFooter = document.querySelector('footer')?.clientHeight
    setHeightLoading(window.screen.availHeight - (heightHeader + heightFooter))
  }, [])

  return (
    <Page>
      {done && <Loading overlay message={WAITING_MESSAGES.RATES_FORM} />}
      <Container device={device} fullScreen={loading}>
        {!loading &&
          <ProductTitle>
            Cotizando {products.find((elem) => {
              return elem.id === Number(productId)
            })?.name}
          </ProductTitle>}
        {loading ? <Loading fullScreen minHeight={heightLoading} size='large' /> : getForm()}
      </Container>
    </Page>
  )
}

export default RatesForm
